export default {
      id: "oc-res-ai-gateway-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-ai-gateway",
      toString: function () {
        return this.url;
      }
    }